import React from 'react';

import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { useBreakpoint } from '~/techstyle-shared/react-components';
import { useDomain } from '~/techstyle-shared/redux-core';

import useUnifiedProductGridData from '../../hooks/useUnifiedProductGridData';
import {
  isFacetOptionSelected,
  updateFiltersInUrlParams,
  sanitizeFilterName,
  getTranslatedFacetOptionDisplayName,
} from '../../utils/filters';
import { scrollToTopOfGrid } from '../../utils/scroll';
import CheckboxInput from '../SharedGridFiltersUi/CheckboxInput';

const Fieldset = styled.fieldset`
  display: flex;
  flex-direction: column;
  gap: 20px;
  border: none;
`;

const Legend = styled.legend`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

const DesktopGridDefaultFilter = ({ options, name }) => {
  const { selectedUrlFilters } = useUnifiedProductGridData();
  const router = useRouter();
  const { isMobile } = useBreakpoint();
  const sanitizedName = sanitizeFilterName(name);
  const domain = useDomain();

  const handleOnChange = ({ facetName, facetOption }) => {
    updateFiltersInUrlParams({
      facetName,
      facetOption,
      router,
    });
    scrollToTopOfGrid({ isMobile });
  };

  return (
    <Fieldset>
      <Legend>{name}</Legend>
      {options?.map((option) => {
        const inputId = `${name}-${option.value}`;
        const isSelected = isFacetOptionSelected({
          facetName: name,
          facetOption: option.value,
          selectedUrlFilters,
        });

        const facetOptionDisplayName = getTranslatedFacetOptionDisplayName({
          facetName: name,
          facetOption: option,
          domain,
        });

        return (
          <CheckboxInput
            key={option.value}
            id={inputId}
            name={option.value}
            label={facetOptionDisplayName}
            checked={isSelected}
            onChange={() =>
              handleOnChange({
                facetName: name,
                facetOption: option.value,
              })
            }
            filterName={sanitizedName}
          />
        );
      })}
    </Fieldset>
  );
};

DesktopGridDefaultFilter.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      display_name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default DesktopGridDefaultFilter;
